import { render, staticRenderFns } from "./GetStartingView.vue?vue&type=template&id=641692fe&scoped=true&"
import script from "./GetStartingView.vue?vue&type=script&lang=js&"
export * from "./GetStartingView.vue?vue&type=script&lang=js&"
import style0 from "./GetStartingView.vue?vue&type=style&index=0&id=641692fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641692fe",
  null
  
)

export default component.exports